<template>
  <div class="process-payment-overlay-container">
    <!-- Opaque background -->
    <div class="process-payment-modal-background" />

    <!-- Inner body -->
    <div
      v-if="inProgress"
      class="process-payment-inner-container"
    >
      <img
        src="/assets/loading-animation.gif"
        alt="loading"
      >
      <h1>Processing Payment</h1>
      <label class="subtitle">Your payment is being processed. Please do not leave this screen.</label>
      <button class="btn-processing">
        Processing...
      </button>
    </div>
    <div
      v-else-if="!inProgress"
      class="process-payment-inner-container"
    >
      <img
        src="/assets/success.gif"
        alt="success"
      >
      <h1>Success!</h1>
      <label class="subtitle">{{ title }}</label>
      <label class="subtitle">{{ subTitle }}</label>
      <label class="btn-order-complete">{{ buttenText }}</label>
      <button
        class="btn-return-site"
        @click="exit()"
      >
        Return to LelandLittle.com
      </button>
    </div>
  </div>
</template>


<script>

export default {
    name: 'ProcessPaymentOverlayComponent',
  components: {  },
    props: [
        'inProgress',
        'paymentType',
        'isPickup',
        'useArta'
    ],
    data () {
		return {
			title: '',
            subTitle: '',
            buttenText: ''
		}
	},

	mounted () {
       if(this.paymentType === 'wire' || this.paymentType === 'check' || this.paymentType === 'zelle' || this.paymentType === 'ach'){
           let typePretty = ''
           if(this.paymentType === 'wire'){
               typePretty = 'wire transfer'
           }
           else if(this.paymentType === 'check'){
               typePretty = 'check'
           }
           else if(this.paymentType === 'zelle'){
               typePretty = 'Zelle'
           }
           else if(this.paymentType === 'ach'){
               typePretty = 'ACH'
           }

           this.title = 'Thank you for notifying the office of your intended payment by ' + typePretty + '.'
           if(this.isPickup){
                this.subTitle = 'We will send a notification to you once the funds have cleared. At that time, pick up may be scheduled.'
           } else if (this.useArta) {
                this.subTitle = 'We will send a notification to you once the funds have cleared. At that time, your ARTA booking will be finalized.'
           } else {
               this.subTitle = 'We will send a notification to you once the funds have cleared.'
           }

           if(this.paymentType === 'ach'){
            this.title = 'Thank you submitting this ACH payment.'
            this.subTitle = 'Processing will take up to 3 business days. Notification will be sent once the payment has cleared.'
           }
           
           this.buttenText = 'Order in Process'
       }
       else {
           this.title = 'Thank you for your purchase. Please check your inbox for confirmation.'
           this.subTitle = ''
           this.buttenText = 'Order Completed'
       }
	},

	methods: {
        exit(){
            this.$emit('clicked')
        }
    },
}
</script>

<style scoped>

</style>